/**
 * Utilitários para manipulação de URLs
 */

/**
 * Adiciona o parâmetro onboarding=skip à URL se o produto for "talks" e FREEMIUM_TALKS estiver no localStorage
 * @param url A URL base para adicionar o parâmetro
 * @param productName O nome do produto (opcional, se não fornecido, não adiciona o parâmetro)
 * @returns A URL com o parâmetro adicionado, se necessário
 */
export const addOnboardingSkipParam = (url: string, productName?: string | undefined): string => {
  if (!productName || productName.toLowerCase() !== "talks") {
    return url;
  }

  const isTalksFreemium = localStorage.getItem("FREEMIUM_TALKS");

  if (!isTalksFreemium) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";

  return `${url}${separator}onboarding=skip`;
};
